import React from 'react';

export default function (props) {
	return (
		<div style={{ ...props.style }}>
			<svg
				viewBox="0 0 127.7 201.1"
				xmlns="http://www.w3.org/2000/svg"
				width={props.size}
				height={props.size}
			>
				<path
					fill={props.theme ? props.theme.primaryColor : props.color}
					style={{ background: '#FFF' }}
					d="M56.1,1.1c9.7-1.3,19.7-0.4,29,3c9.1,3.4,17.6,8.8,24.4,15.8c0.1,0.1,0.3,0.3,0.4,0.4c18.3,19.3,22.6,45,10.5,69.7
					c-6.1,12.5-14.1,24.1-21.9,35.6c-13.1,19.1-23.9,39.1-29.9,61.6c-1.2,4.5-2.3,9-3.5,13.5c-0.7,0-1.3,0-2,0c-0.5-2.4-1-4.9-1.6-7.3
					C55.2,168.8,44,146.7,29.7,126C22,114.9,13.8,104,7.6,92.2C-8.1,62,3.2,25.1,32.7,8.8C39.9,4.9,47.9,2.2,56.1,1.1z M40.7,64.5
					C40.7,78,51.6,89.3,64.4,89.2c13.3,0,24.2-11.3,24.1-24.9c0-13.5-10.6-23.9-24.3-23.8C51,40.5,40.6,51,40.7,64.5z"
				/>
			</svg>
		</div>
	);
}
